import getUrlBase from "datastore/getUrlBase";
import paramsToQs from "util/paramsToQs";

// delete is a reserved keyword
export default async function fetchDelete(url, params) {
  let fullUrl = `${getUrlBase()}${url}`;
  if (params && Object.keys(params).length > 0) {
    const urlParams = paramsToQs(params);
    fullUrl = `${getUrlBase()}${url}?${urlParams}`;
  }
  return fetch(fullUrl, {
    method: "DELETE",
    mode: "cors",
  });
}
